import { atom } from 'jotai'

export const goAdminPageAtom = atom<boolean>(false)

export const hasOpenedModifyPasswordAtom = atom<boolean>(false)
